/*
 * NOTICE OF LICENSE
 *
 * This source file is subject to the Academic Free License (AFL 3.0)
 *
 *  @author    Afternet <info@afternet.gr>
 *  @copyright 2022 Afternet
 *  @license   http://opensource.org/licenses/afl-3.0.php  Academic Free License (AFL 3.0)
 */
import React from 'react';
import axios from 'axios';
import useAccessToken from "./useAccessToken";
import useLang from "./useLang";
import {useTranslation} from "react-i18next";

const useAxiosJTW = () =>{

    //const refresh = useRefreshToken();
    const getAccessToken = useAccessToken();
    const { t, i18n } = useTranslation();
    const baseURL = `${process.env.REACT_APP_URL}${i18n.language}`;

    const axiosInstance = axios.create({
        baseURL,
        headers: {
            'Content-Type': 'application/json',
            //Authorization: `Bearer ${Token}`,       // for Spring Boot back-end
            //"x-access-token" : Token                //for Node.js Express back-end
        },
        //withCredentials: true
    });


    const axiosInstanceRequest = axiosInstance.interceptors.request.use(
        async config => {

            //const accessToken = await getAccessToken();
            const accessToken = localStorage.getItem('accessToken') ? JSON.parse(localStorage.getItem('accessToken')) : null;
            if(accessToken){
                config.headers['authorization'] = `${accessToken}`;  //${accessToken}
            }

            //if (!config.headers['Authorization']) {
                //let Token = localStorage.getItem('Token') ? JSON.parse(localStorage.getItem('Token')) : null;
                //config.headers['Authorization'] = `${token}`;
            //}

            return config;
        }, (error) => Promise.reject(error)
    );

    const axiosInstanceResponse = axiosInstance.interceptors.response.use( async (response) => {

        const prevRequest = response?.config;
        if (response?.data?.invalid_token == true && !prevRequest?.sent){
            prevRequest.sent = true;
            try {

                const newAccessToken = await getAccessToken();
                prevRequest.headers['authorization'] = `${newAccessToken}`;
                return axiosInstance(prevRequest);

            }catch (error) {
                return response;
            }
        }

        return response;
    },  async (error) => {

        const prevRequest = error?.config;
        if (error?.response?.status == 401 && !prevRequest?.sent){
            prevRequest.sent = true;
            try {

                const newAccessToken = await getAccessToken();
                prevRequest.headers['authorization'] = `${newAccessToken}`;
                return axiosInstance(prevRequest);

            }catch (error) {
                return Promise.reject(error);
            }
        }

        return Promise.reject(error);
    });


    return axiosInstance;

}

export default useAxiosJTW;

